const slack = require('slack');

const token = process.env.REACT_APP_SLACK_TOKEN;

const postSlackMessage = (text, channel = '#dashboard-errors') => slack.chat.postMessage({ token, channel, text });

export { postSlackMessage };
